// src/utils/bus.js
const map = new Map(); // event -> Set<fn>

export function on(evt, fn) {
  if (!map.has(evt)) map.set(evt, new Set());
  map.get(evt).add(fn);
}

export function off(evt, fn) {
  map.get(evt)?.delete(fn);
}

export function emit(evt, payload) {
  map.get(evt)?.forEach(fn => {
    try { fn(payload); } catch (e) { console.error(e); }
  });
}
